import gql from 'graphql-tag';

export const UPSERT_CREDIT_SUBMISSION_ASSIGNMENT_TITLES = gql`
  mutation UpsertCreditSubmissionAssignmentTitles($input: UpsertCreditSubmissionAssignmentTitlesInput!) {
    upsertCreditSubmissionAssignmentTitles(input: $input) {
      creditSubmissionAssignmentTitleId
      creditSubmissionId
      userProfileId
      title
    }
  }
`;
